import React from "react";
import PlatformType from "../../types/PlatformType";
import {platformInfo} from "../../services/Platform";
import styles from "./Apps.module.css";

export default function PlatformBadge({platform}: { platform: PlatformType }) {
    const info = platformInfo(platform);
    return (
        <span className={styles.platformBadge}>
            <span className={styles.platformIcon} aria-hidden>{info.icon}</span>
            {info.name}
        </span>
    );
}
